// extracted by mini-css-extract-plugin
module.exports = {"content":"slug_content__RAMEj","date":"slug_date__TnPYO","categories":"slug_categories__GfupF"};